// @flow
/**
 * PRODUCTS MODULE EXPORTS
 * This is the "interface" file for the user module.
 * You should only use exports from this file.
 */

/**
 * Imports
 * =======
 * Import default exports from files inside
 * the module
 */
import reducer from './reducer';
import ProductSquare from './components/ProductSquare';
import ProductPromotionScroller from './containers/scrollers/ProductPromotionScroller';
import ProductRecentlyViewedScroller from './containers/scrollers/ProductRecentlyViewedScroller';
import ProductRecommendedForUserScroller from './containers/scrollers/ProductRecommendedForUserScroller';
import ProductRelatedProductsScroller from './containers/scrollers/ProductRelatedProductsScroller';
import ProductMostSoldScroller from './containers/scrollers/ProductMostSoldScroller';
import SubdepartmentScroller from './containers/SubdepartmentScroller';
import ProductPage from './containers/ProductPage';
import NotifyMeWhenStockRenewed from './containers/NotifyMeWhenStockRenewed';
import findMultipleProductsConnector from './connectors/findMultipleProductsConnector';
import displayVariantsByPageAndSectionConnector from './connectors/displayVariantsByPageAndSectionConnector';
import type { Product } from './types';
/**
 * Reducer
 * =======
 * The default export is the reducer to be integrated in the Redux Store.
 * Its state is defined too, and exported as the type UserStoreState.
 */
export default reducer;
export type { StoreState as ProductStoreState } from './types/StoreState';

/**
 * Widgets
 * =======
 * Widgets are connected components that can be used inside a page.
 */
export {
  ProductPromotionScroller,
  ProductRecentlyViewedScroller,
  ProductRecommendedForUserScroller,
  ProductRelatedProductsScroller,
  SubdepartmentScroller,
  ProductMostSoldScroller,
  NotifyMeWhenStockRenewed,
  ProductSquare,
};

/**
 * Pages
 * =====
 * Pages are components that are used in the router.
 * They are auto-rendered by react-router and thus have
 * to be self-sufficient (no passed props).
 */
export { ProductPage };
export type { Product };
/**
 * HOCs and Connectors
 * ===================
 * Higher order components and connectors wrap the children component
 * and add behavior or props that depend on the internal user state.
 */
export {
  findMultipleProductsConnector,
  displayVariantsByPageAndSectionConnector,
};
